/**
* API 调用记录
*/
<template>
	<div style="display: flex;flex-direction: column; height: 93.45vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false" style="z-index: 2000;">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div style="margin-top: 10px; display: flex; align-items: center; justify-content: center;">

			<el-form ref="form" :model="form" label-width="120px">
				<!-- 设备类型 -->
				<el-form-item :label="$t('language000289')">
					<el-select v-model="form.activityRegion" clearable :placeholder="$t('language000290')"
						@change="select" style="width: 300px;">

						<!-- <el-option label="梨花肛塞" value="2"></el-option>
						<el-option label="小恶魔" value="3"></el-option>
						<el-option label="电击拍" value="5"></el-option>
						<el-option label="二代肛塞" value="9"></el-option>
						<el-option label="尾巴" value="12"></el-option> -->

						<!-- 一代钥匙盒子 -->
						<el-option label="Key Pod (I)" value="6"></el-option>
						<!-- 二代钥匙盒 -->
						<el-option label="Key Pod (II)" value="11"></el-option>
						<!-- 一代锁 -->
						<el-option label="Cag Ink (I)" value="1"></el-option>
						<!-- 二代锁(旧图标)4  二代锁(新图标)7 应该不会有旧图标，所以默认是7-->
						<el-option label="Cag Ink (II)" value="7"></el-option>
						<!-- 三代锁 -->
						<el-option label="Cag Ink (III)" value="10"></el-option>
						<el-option label="伪娘锁(CC锁)" value="19"></el-option>
						<el-option label="金属钥匙盒" value="20"></el-option>
						<el-option label="Thrill Cage(OEM锁)" value="21"></el-option>
						<el-option label="silibration_cage(硅胶震动锁)" value="22"></el-option>

					</el-select>
				</el-form-item>
			</el-form>


			<el-form ref="form" :model="form" label-width="120px">
				<!-- 命令类型 1开锁，2关锁，3定时开锁，4电击，5定时电击，6震动，7定时震动，8模式切换，9 4g切换-->
				<el-form-item :label="$t('language000309')">
					<el-select v-model="form.activityRegion01" clearable :placeholder="$t('language000290')"
						@change="select01" style="width: 300px;">
						<!-- 开锁命令 -->
						<el-option :label="$t('language000191')" value="1"></el-option>
						<!-- 关锁命令 -->
						<el-option :label="$t('language000192')" value="2"></el-option>
						<!-- 定时开锁 -->
						<el-option :label="$t('language000310')" value="3"></el-option>
						<!-- 电击-->
						<el-option :label="$t('language000311')" value="4"></el-option>
						<!-- 定时电击 -->
						<el-option :label="$t('language000312')" value="5"></el-option>
						<!-- 震动 -->
						<el-option :label="$t('language000313')" value="6"></el-option>
						<!-- 定时震动 -->
						<el-option :label="$t('language000314')" value="7"></el-option>
						<!-- 模式切换 -->
						<el-option :label="$t('language000315')" value="8"></el-option>
						<!-- 4g切换 -->
						<el-option :label="$t('language000316')" value="9"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<el-form ref="form" :model="form" label-width="120px">
				<!-- 入库时间 -->
				<el-form-item :label="$t('language000291')">
					<el-date-picker v-model="value" type="daterange" @change="selectTime"
						:start-placeholder="$t('language000292')" :end-placeholder="$t('language000293')"
						:default-time="['00:00:00', '23:59:59']">
					</el-date-picker>
				</el-form-item>
			</el-form>

		</div>

		<div
			style="margin-top: -10px; margin-bottom: 10px;  display: flex; align-items: center; justify-content: center;">

			<!-- 环境选择 0测试true  1正式false -->
			<el-switch v-model="environmentType" :active-text="$t('language000178')"
				:inactive-text="$t('language000177')" @change="switchingEnvironments" inactive-color="#13ce66">
			</el-switch>

			<el-form ref="form" :model="form" label-width="80px" style="margin-left: 20px;">
				<!-- 设备ID -->
				<el-input :placeholder="$t('language000294')" v-model="deviceID" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="selectDeviceID"></el-button>
				</el-input>
			</el-form>

			<el-form ref="form" :model="form" label-width="80px" style="margin-left: 20px;">
				<!-- 设备编码 -->
				<el-input :placeholder="$t('language000295')" v-model="deviceNumber" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="selectDeviceID"></el-button>
				</el-input>
			</el-form>

		</div>

		<!-- 列表 -->
		<el-table v-if="tableData" :data="tableData" height="200" stripe border
			style="width: 100%; flex: 1; overflow: auto;" :default-sort="{order: 'descending' }">
			<el-table-column type="index" :index="indexMethod"></el-table-column>
			<!-- 创建时间 -->
			<el-table-column prop="createTime" :label="$t('language000296')" align="center" width="330"
				sortable></el-table-column>
			<!-- 设备ID -->
			<el-table-column prop="id" :label="$t('language000329')" align="center" width="200"
				sortable></el-table-column>
			<!-- 设备编码 -->
			<el-table-column prop="serialNumber" :label="$t('language000295')" align="center"
				width="300"></el-table-column>
			<!-- 设备类型 -->
			<el-table-column :label="$t('language000289')" align="center" width="260">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 13px;">{{ scope.row.typeId }}</p>
					</div>
				</template>
			</el-table-column>
			<!-- 命令类型 -->
			<el-table-column fixed="right" prop="cmdType" :label="$t('language000309')"align="center">

			</el-table-column>
		</el-table>


		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	// 引入公用方法
	import {
		getError
	} from '../../../../../src/utils/StringUtil.js';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				tableData: null, //数据类型
				environmentType: false, //0测试true  1正式false
				form: {
					activityRegion: '', // 根据需要添加其他表单字段
					activityRegion01: '', // 根据需要添加其他表单字段
				},
				total: 1, //一共有多少条数据
				whichArticle: 1, //这是第几条
				value: '', //时间
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				cmdType: "", //命令类型
				startTime: 0, //开始时间
				endTime: 0, //结束时间
				deviceID: "", //要查询的设备ID
				deviceNumber: "", //要查询的设备编码
				typeId: 0, //设备类型
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize);
		},
		methods: {
			fetchData(pageNum, pageSize) {
				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {};
				if (this.environmentType) { //数据环境  0测试true  1正式false
					requestData.environmentType = "0";
				} else {
					requestData.environmentType = "1";
				}
				if (this.typeId != 0) {
					requestData.typeId = this.typeId; //设备类型
				}
				if (this.startTime != 0) {
					requestData.startTime = this.startTime; //开始时间
				}
				if (this.endTime != 0) {
					requestData.endTime = this.endTime; //结束时间
				}
				if (this.deviceID.length != 0) {
					requestData.id = this.deviceID; //设备ID
				}
				if (this.deviceNumber.length != 0) {
					requestData.serialNumber = this.deviceNumber; //设备编码
				}
				if (this.cmdType.length != 0) {
					requestData.cmdType = this.cmdType; //蓝牙地址
				}

				console.log("API记录查询：", requestData)
				this.loadingData = true;
				axios.post(this.$p_url_Developers + '/platform/device/apiCalls/list?page=' + pageNum + '&limit=' +
						pageSize,
						requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'authorization': Cookies.get("tokenDevelopment"),
							},
						})
					.then(response => {
						this.loadingData = false;
						console.log("记录查询 返回：", response.data)
						const state = response.data.state; // 获取状态
						if (response.data.code === 401) { //登录失效
							Cookies.remove("tokenDevelopment");
							this.$router.push({ //跳转到登录
								path: '/DevelopersLogin',
								query: {}
							});
						} else if (response.data.code === 200) { // 检查状态
							if (response.data.data.list != null) {
								this.total = response.data.data.total; //一共有多少条数据
								for (let i = 0; i < response.data.data.list.length; i++) {
									//修改设备类型 1 cellmate  pearFlower  3 little devil  4 7 二代锁  6 钥匙盒  5 拍子  9 肛塞 10三代锁
									switch (response.data.data.list[i].typeId) {
										case 19: //伪娘锁(CC锁)
											response.data.data.list[i].typeId = "伪娘锁(CC锁)";
											break
										case 20: //金属钥匙盒
											response.data.data.list[i].typeId = "金属钥匙盒";
											break
										case 21: //Thrill Cage(OEM锁)
											response.data.data.list[i].typeId = "Thrill Cage(OEM锁)";
											break
										case 22: //silibration_cage(硅胶震动锁)
											response.data.data.list[i].typeId = "silibration_cage(硅胶震动锁)";
											break
										case 6: //一代钥匙盒
											response.data.data.list[i].typeId = "Key Pod (I)";
											break
										case 11: //二代钥匙盒
											response.data.data.list[i].typeId = "Key Pod (II)";
											break
										case 1: //一代锁
											response.data.data.list[i].typeId = "Cag Ink (I)";
											break
										case 4: //二代锁(旧标)
										case 7: //二代锁(新标)
											response.data.data.list[i].typeId = "Cag Ink (II)";
											break
										case 10: //三代锁
											response.data.data.list[i].typeId = "Cag Ink (III)";
											break
										case 2:
											response.data.data.list[i].typeId = "梨花肛塞";
											break
										case 3:
											response.data.data.list[i].typeId = "小恶魔";
											break
										case 5:
											response.data.data.list[i].typeId = "电击拍";
											break
										case 9:
											response.data.data.list[i].typeId = "二代肛塞";
											break
										case 12:
											response.data.data.list[i].typeId = "尾巴";
											break
									}
									//入库时间将时间戳转换为具体的时间
									response.data.data.list[i].createTime = this.formatDate(response.data.data.list[i]
										.createTime);

									//修改命令类型 1开锁，2关锁，3定时开锁，4电击，5定时电击，6震动，7定时震动，8模式切换，9 4g切换
									switch (response.data.data.list[i].cmdType) {
										case 1: //开锁命令
											response.data.data.list[i].cmdType = this.$t('language000191') //开锁命令
											break
										case 2: //关锁命令
											response.data.data.list[i].cmdType = this.$t('language000192') //关锁命令
											break
										case 3: //定时开锁
											response.data.data.list[i].cmdType = this.$t('language000310') //定时开锁
											break
										case 4: //电击
											response.data.data.list[i].cmdType = this.$t('language000311') //电击
											break
										case 5: //定时电击
											response.data.data.list[i].cmdType = this.$t('language000312') //定时电击
											break
										case 6: //震动
											response.data.data.list[i].cmdType = this.$t('language000313') //震动
											break
										case 7: //定时震动
											response.data.data.list[i].cmdType = this.$t('language000314') //定时震动
											break
										case 8: //模式切换
											response.data.data.list[i].cmdType = this.$t('language000315') //模式切换
											break
										case 9: //4g切换
											response.data.data.list[i].cmdType = this.$t('language000316') //4g切换
											break
										case 10: //getToken
											response.data.data.list[i].cmdType = 'getToken'
											break
										case 11: //解密命令
											response.data.data.list[i].cmdType = this.$t('language000326') //解密命令
											break
										case 12: //关机
											response.data.data.list[i].cmdType = this.$t('language000327') //关机
											break
										case 13: //状态查询
											response.data.data.list[i].cmdType = this.$t('language000328') //状态查询
											break
									}

								}
								this.tableData = response.data.data.list;
							} else {
								this.tableData = [];
							}
						} else {
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					}).catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			switchingEnvironments(index) { //切换环境
				this.fetchData(1, this.pageSize);
			},
			formatter(row, column) {
				return row.address;
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			select() { //选中了某个值
				this.typeId = this.form.activityRegion;
				this.fetchData(1, this.pageSize);
			},
			select01() { //选中了某个值
				this.cmdType = this.form.activityRegion01;
				this.fetchData(1, this.pageSize);
			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			selectDeviceID() { //输入了条件进行查询
				this.fetchData(1, this.pageSize);
			},
			formatDate(timestamp) {
				const date = new Date(timestamp);
				// 获取年月日时分秒
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0操作
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
		},
		//...
	};
</script>
